import { writable, get } from 'svelte/store';


import { set as storageSet, get as storageGet } from '@/helpers/storage';


const _default = {
	token: '',
	time: '',
};


const { subscribe, set, update } = writable(Object.assign({}, _default));


export const token = {
	subscribe,

	/* pull */
	pull: prop =>
		prop ? get(token)[prop] : get(token),
	
	/* push */
	push: value =>
		update(self => Object.assign(self, value)),

	/* reset */
	reset: () =>
		update(self => Object.assign(self, _default)),

	/* save */
	save: () =>
		storageSet(':token', get(token)),

	/* load */
	load: () =>
		update(self => Object.assign(self, storageGet(':token'))),
};
